import React from 'react';
import { Container, EmailButton, Section } from '../components';

const Footer = () => (
  <Section>
    <Container className="tc">
      <h4 className="mt0 f4">Kontakta oss</h4>
      <EmailButton />
    </Container>
  </Section>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/partials/footer.js